import { allocationAPI } from '../../helper/apis';

export const updateCategories = (idCategory, params) => allocationAPI.put(`/service-categories/${idCategory}`,
  {
    isAvailableForOrderAllocation: params
  });